import React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import useMediaQuery from "@mui/material/useMediaQuery";

import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function PrettyPagination({
  page,
  totalPages,
  totalCount,
  onChange,
  labelSingolare = "richiesta",
  labelPlurale = "richieste",
  className = "",
}) {
  const isMobile = useMediaQuery("(max-width: 640px)");

  if (!totalPages || totalPages <= 1) return null;

  const label = totalCount === 1 ? labelSingolare : labelPlurale;

  return (
    <div className={`w-full flex flex-col items-center gap-2 ${className}`}>
      <Pagination
        page={page}
        count={totalPages}
        onChange={(_, value) => onChange(value)}
        shape="rounded"
        color="standard"
        size={isMobile ? "small" : "medium"}
        siblingCount={isMobile ? 0 : 1}
        boundaryCount={isMobile ? 1 : 1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{
              first: FirstPageIcon,
              last: LastPageIcon,
              previous: KeyboardArrowLeftIcon,
              next: KeyboardArrowRightIcon,
            }}
          />
        )}
        showFirstButton
        showLastButton
      />

      <div className="text-sm text-gray-600">
        Pagina <span className="font-medium text-gray-900">{page}</span> di{" "}
        <span className="font-medium text-gray-900">{totalPages}</span> ·{" "}
        <span className="font-medium text-gray-900">{totalCount}</span> {label} totali
      </div>
    </div>
  );
}
